import Main from '~/layout/DefaultLayout/Main/Main';

const Home = () => {
    return (
        <div>
            <Main />
        </div>
    );
};

export default Home;
